import React, { useEffect, useState } from "react";
import Content from "../../Components/Core/Content";
import FormInput from "../../Components/Core/FormInput";
import { Button, MenuItem, Select, FormControl, Checkbox } from "@mui/material";
import PersianDatePicker from "../../Components/Core/DatePicker";
import { formatDate } from "../../Services/GeneralService";
import {
  CreateManualReservation,
  fetchAvailableSlots,
} from "../../Services/ReservationService";
import Loader from "../../Components/Core/Loader";
import Notification from "../../Components/Core/Notification";

const ManualReserve = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [date, setDate] = useState(null);
  const [availableTimes, setAvailableTimes] = useState([]);
  const [startTime, setStartTime] = useState("");
  const [isInitial, setIsInitial] = useState(true);
  const [timeLoading, setTimeLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isPayed, setIsPayed] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const dateChangeHandler = async (date) => {
    try {
      setIsInitial(false);
      setDate(date);
      setTimeLoading(true);
      const availableSlots = await fetchAvailableSlots(formatDate(date));
      setAvailableTimes(availableSlots || []);
    } catch (error) {
      console.error(error);
    } finally {
      setTimeLoading(false);
    }
  };

  const clearInput = () => {
    setFirstName("");
    setLastName("");
    setMobileNumber("");
    setAvailableTimes([]);
    setStartTime("");
    setDate(null);
    setIsPayed(false);
    setIsInitial(true);
  };

  const submitHandler = async () => {
    try {
      setLoading(true);
      await CreateManualReservation({
        firstName,
        lastName,
        mobileNumber,
        date,
        startTime,
        isPayed,
      });
      setSnackbarSeverity("success");
      setSnackbarMessage("رزرو با موفقیت ثبت شد");
      setOpenSnackbar(true);
    } catch (error) {
      setSnackbarSeverity("error");
      setSnackbarMessage(error.message);
      setOpenSnackbar(true);
    } finally {
      setLoading(false);
      clearInput();
    }
  };

  useEffect(() => {
    document.title = "ثبت رزرو";
  }, []);

  return (
    <Content>
      {loading ? (
        <Loader />
      ) : (
        <div className="container color-blue">
          <h2 className="mb-4 row mt-5 highlight-box highlight-secondary fw-bold color-blue">
            <span>ثبت رزرو</span>
          </h2>
          <div className="row justify-content-between mt-5">
            <div className="col-md-4 col-11">
              <FormInput
                className="form-blue"
                name={"نام"}
                onChange={(e) => setFirstName(e.target.value)}
                value={firstName}
                for={"firstName"}
              />
            </div>
            <div className="col-md-4 col-11">
              <FormInput
                name={"نام خانوادگی"}
                onChange={(e) => setLastName(e.target.value)}
                value={lastName}
                for={"lastName"}
              />
            </div>
            <div className="col-md-4 col-11">
              <FormInput
                name={"شماره موبایل"}
                onChange={(e) => setMobileNumber(e.target.value)}
                value={mobileNumber}
                for={"mobileNumber"}
              />
            </div>
          </div>
          <div className="row align-items-center  ">
            <div className="col-11 mb-3 mb-md-0 col-md-4">
              <div className="row">
                <label htmlFor="date" className="form-label col-12">
                  <span>تاریخ</span>{" "}
                </label>
                <PersianDatePicker
                  inputProps={{ readOnly: true }} 
                  placeholder={"تاریخ رزرو را وارد کنید"}
                  value={date}
                  onChange={dateChangeHandler}
                />
              </div>
            </div>
            <div className="col-11 mb-3 mb-md-0 col-md-4">
              <div className="row">
                <label htmlFor="time" className="form-label col-12">
                  <span>ساعت</span>{" "}
                </label>
                <div className="col-12">
                  {" "}
                  <FormControl fullWidth>
                    <Select
                      labelId="start-time-label"
                      value={startTime}
                      onChange={(e) => setStartTime(e.target.value)}
                      disabled={isInitial || timeLoading}
                      sx={{
                        height: "34px",
                      }}
                    >
                      {availableTimes.length === 0 ? (
                        <MenuItem value="">
                          <span>زمانی برای این تاریخ موجود نیست</span>
                        </MenuItem>
                      ) : (
                        availableTimes.map((time) => (
                          <MenuItem key={time} value={time}>
                            <span> {time}</span>
                          </MenuItem>
                        ))
                      )}
                    </Select>
                  </FormControl>
                </div>
              </div>
            </div>

            <div className="col-11 mb-3 mb-md-0 col-md-4 p-0 pt-md-4 mb-4">
              <div className="row align-items-center pt-2">
                {" "}
                <div className="col-2 col-md-1 m-0 m-md-2">
                  <Checkbox
                    checked={isPayed}
                    onChange={(e) => setIsPayed(e.target.checked)}
                    name="isPayed"
                    color="primary"
                    size="medium"
                  />
                </div>
                <div className="col d-flex align-items-center p-0">
                  {" "}
                  <span>پرداخت شده</span>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12 mt-2 pb-5">
              <Button
                variant="contained"
                className="btn-blue  w-auto px-5"
                onClick={submitHandler}
              >
                <span>ثبت</span>
              </Button>
            </div>
          </div>
        </div>
      )}

      <Notification
        openSnackbar={openSnackbar}
        snackbarMessage={snackbarMessage}
        snackbarSeverity={snackbarSeverity}
        setOpenSnackbar={setOpenSnackbar}
      />
    </Content>
  );
};

export default ManualReserve;
